import { MapUtils } from '../../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../../dto/data-model-utils.js';
import {
  SerializedData, SerializationContext, DataModelBuilder,
} from '../../../dto/data-model.js';
import { OnlineEventPassOrder } from '../../online-event-pass-order.js';
import { AuditLogEntryType } from '../audit-log-entry-type.js';
import { AuditLogEntry } from '../audit-log-entry.js';

export class OnlineEventPassOrderCreatedEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = '5bbcd56284f24aa39eba6b5bdfbabc9d';

  private constructor(
    public readonly order: OnlineEventPassOrder,
  ) {
    super();
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.OnlineEventPassOrderCreated;
  }

  get $typeId(): string {
    return OnlineEventPassOrderCreatedEntry.TYPE_ID;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.order.businessRef.encode(),
      orderId: this.order.uniqueId,
      customerId: this.order.creatorId,
      isGuestOrder: this.order.isGuestOrder,
    };
  }

  static create(args: {
    order: OnlineEventPassOrder,
  }): OnlineEventPassOrderCreatedEntry {
    return new OnlineEventPassOrderCreatedEntry(args.order);
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): OnlineEventPassOrderCreatedEntry {
    return this.create({
      order: context.fromData<OnlineEventPassOrder>(MapUtils.getRecord(map, 'order')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      order: context.toData(this.order),
    };
  }

  clone(): this {
    return OnlineEventPassOrderCreatedEntry.create({
      order: cloneData(this.order),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.order, this.order);
  }
}

export class OnlineEventPassOrderCreatedEntryBuilder extends DataModelBuilder<OnlineEventPassOrderCreatedEntry> {
  build(context: SerializationContext, map: SerializedData): OnlineEventPassOrderCreatedEntry {
    return OnlineEventPassOrderCreatedEntry.fromMap(context, map);
  }
}
